<template>
   <Head>
      <title>{{ metaTitle }}</title>
      <meta name="description" :content="metaDescription" />
      <meta property="og:title" :content="metaTitle" />
      <meta property="og:description" :content="metaDescription" />
      <meta property="og:image" :content="metaImage" />
   </Head>
   <PageLoader :isLoading="isLoading" :loadErrors="loadErrors" :loadErrorMessage="loadErrorMessage">
      <BlogpostContent v-if="blogpostResp" class="my-5 px-5" hasHeaderSection :blogpost="blogpostResp" />
   </PageLoader>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { Head } from "@unhead/vue/components";
import { useI18n } from "@/vue-i18n/vue-i18n";
import axios from "axios";
import BlogpostsApi, { type Blogpost } from "@/data/api-layer/blogpostsApi";

const { isLoading, execRequest, loadErrors } = useApiRequest();
const $route = useRoute();
const { t: $t } = useI18n();

const loadErrorMessage = ref<string>("");
const blogpostResp = ref<Blogpost | null>(null);
const blogpostKey = $route.params.key as string;

onMounted(async () => {
   // Admin/Team members should have access to unpublished content
   const response = await execRequest(() => BlogpostsApi.getOneByKey(blogpostKey));
   if (loadErrors.value.length > 0) {
      if (axios.isAxiosError(loadErrors.value[0]) && loadErrors.value[0].response?.status === 404) {
         loadErrorMessage.value = $t("validation.blogpost_not_found");
      }
      return;
   }

   blogpostResp.value = response;
});

const metaTitle = computed(() => {
   return blogpostResp.value?.title || $t("meta.blogs.title");
});

const metaDescription = computed(() => {
   return blogpostResp.value?.socialShareText || blogpostResp.value?.subtitle || $t("meta.blogs.content");
});

const metaImage = computed(() => {
   return blogpostResp.value?.imageHero_620w || "";
});
</script>

<style scoped></style>
